export const getDefaultPathByPermissions = (tabs, basePath, permissions = []) => {
  const firstAllowed = tabs.find(tab => permissions.includes(tab.permission));
  return firstAllowed
    ? `${basePath}/${firstAllowed.to.replace(`${basePath}/`, '')}`
    : `${basePath}`;
};
